webpackJsonp([182305654616262,103601275646562,60031100540890],{

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactCore = __webpack_require__(3);
	
	var _SimpleSplit = __webpack_require__(225);
	
	var _SimpleSplit2 = _interopRequireDefault(_SimpleSplit);
	
	var _SplitWithGutter = __webpack_require__(226);
	
	var _SplitWithGutter2 = _interopRequireDefault(_SplitWithGutter);
	
	var _getContainerProps = __webpack_require__(562);
	
	var _getContainerProps2 = _interopRequireDefault(_getContainerProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  title: 'Split',
	  components: {
	    Split: _reactCore.Split,
	    SplitItem: _reactCore.SplitItem
	  },
	  enumValues: {
	    'Object.keys(GutterSize)': Object.keys(_reactCore.GutterSize)
	  },
	  examples: [{ component: _SimpleSplit2.default, title: 'Simple Split Layout', getContainerProps: _getContainerProps2.default }, { component: _SplitWithGutter2.default, title: 'Split Layout With Gutter', getContainerProps: _getContainerProps2.default }]
	};
	module.exports = exports['default'];

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleSplit = function (_React$Component) {
	  _inherits(SimpleSplit, _React$Component);
	
	  function SimpleSplit() {
	    _classCallCheck(this, SimpleSplit);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SimpleSplit.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.Split,
	      null,
	      _react2.default.createElement(
	        _reactCore.SplitItem,
	        null,
	        'Secondary content'
	      ),
	      _react2.default.createElement(
	        _reactCore.SplitItem,
	        { isMain: true },
	        'Primary Content'
	      ),
	      _react2.default.createElement(
	        _reactCore.SplitItem,
	        null,
	        'Secondary content'
	      )
	    );
	  };
	
	  return SimpleSplit;
	}(_react2.default.Component);
	
	exports.default = SimpleSplit;
	SimpleSplit.__docgenInfo = {
	  'description': '',
	  'displayName': 'SimpleSplit'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Split, SplitItem } from '@patternfly/react-core';\n\nclass SimpleSplit extends React.Component {\n  render() {\n    return (\n      <Split>\n        <SplitItem>Secondary content</SplitItem>\n        <SplitItem isMain>Primary Content</SplitItem>\n        <SplitItem>Secondary content</SplitItem>\n      </Split>\n    );\n  }\n}\n\nexport default SimpleSplit;\n"

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCore = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SplitWithGutter = function (_React$Component) {
	  _inherits(SplitWithGutter, _React$Component);
	
	  function SplitWithGutter() {
	    _classCallCheck(this, SplitWithGutter);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitWithGutter.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactCore.Split,
	      { gutter: 'md' },
	      _react2.default.createElement(
	        _reactCore.SplitItem,
	        null,
	        'Secondary content'
	      ),
	      _react2.default.createElement(
	        _reactCore.SplitItem,
	        { isMain: true },
	        'Primary Content'
	      ),
	      _react2.default.createElement(
	        _reactCore.SplitItem,
	        null,
	        'Secondary content'
	      )
	    );
	  };
	
	  return SplitWithGutter;
	}(_react2.default.Component);
	
	exports.default = SplitWithGutter;
	SplitWithGutter.__docgenInfo = {
	  'description': '',
	  'displayName': 'SplitWithGutter'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

	module.exports = "import React from 'react';\nimport { Split, SplitItem } from '@patternfly/react-core';\n\nclass SplitWithGutter extends React.Component {\n  render() {\n    return (\n      <Split gutter=\"md\">\n        <SplitItem>Secondary content</SplitItem>\n        <SplitItem isMain>Primary Content</SplitItem>\n        <SplitItem>Secondary content</SplitItem>\n      </Split>\n    );\n  }\n}\n\nexport default SplitWithGutter;\n"

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactStyles = __webpack_require__(5);
	
	var _reactTokens = __webpack_require__(16);
	
	var styles = _reactStyles.StyleSheet.create({
	  demoLayout: {
	    '& .pf-l-split > .pf-l-split__item': {
	      borderWidth: _reactTokens.global_BorderWidth_md.var,
	      borderStyle: 'dashed',
	      borderColor: _reactTokens.global_BorderColor.var
	    }
	  }
	});
	
	exports.default = function () {
	  return { className: (0, _reactStyles.css)(styles.demoLayout) };
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.split_package = exports.split_docs = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SplitDocs = __webpack_require__(561);
	
	var _SplitDocs2 = _interopRequireDefault(_SplitDocs);
	
	var _componentDocs = __webpack_require__(15);
	
	var _componentDocs2 = _interopRequireDefault(_componentDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rawExamples = [{ name: 'SimpleSplit', path: '../../react-core/src/layouts/Split/examples/SimpleSplit.js', file: __webpack_require__(465) }, { name: 'SplitWithGutter', path: '../../react-core/src/layouts/Split/examples/SplitWithGutter.js', file: __webpack_require__(466) }];
	var images = [{ name: 'img_avatar.svg', file: __webpack_require__(7) }, { name: 'l_pf-reverse-164x11.png', file: __webpack_require__(8) }, { name: 'pf_logo.svg', file: __webpack_require__(9) }, { name: 'pf_mini_logo_white.svg', file: __webpack_require__(10) }, { name: 'img_avatar.svg', file: __webpack_require__(12) }, { name: 'pf_logo.svg', file: __webpack_require__(13) }, { name: 'pf_logo_color.svg', file: __webpack_require__(14) }, { name: 'pfbg_992.jpg', file: __webpack_require__(11) }];
	
	var split_docs = exports.split_docs = _SplitDocs2.default;
	var split_package = exports.split_package = 'react-core';
	
	exports.default = function () {
	    return _react2.default.createElement(_componentDocs2.default, _extends({ rawExamples: rawExamples, images: images }, _SplitDocs2.default));
	};

/***/ })

});


// WEBPACK FOOTER //
// component---tmp-split-docs-js-5d107eef8d9ead16a696.js